var map = {
	"./black/jieshu2.png": "DtXJ",
	"./blue/jieshu2.png": "eC06",
	"./white/jieshu2.png": "nLAr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "keVl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/jieshu2\.png$
// module id = keVl
// module chunks = 24